import React from "react";
import { PropTypes } from "prop-types";
import { map } from "lodash";
import { observer } from "mobx-react";
import { CategoryGridCell } from "application/categories/components";

function CategoryGroupTemplate({ item, goTo, premiumSubscriptionStore, manageSelectedItemsViewStore, onCellClick }) {
    return (
        <div className="u-mar--bottom--sml">
            <p className="u-type--base u-type--wgt--bold u-mar--bottom--tny">{item.genreName || "General Content"}</p>
            <div className="u-display--flex u-gap--sml u-display--flex--wrap">
                {map(item.homeContents, (item) => (
                    <CategoryGridCell
                        goTo={goTo}
                        premiumSubscriptionStore={premiumSubscriptionStore}
                        manageSelectedItemsViewStore={manageSelectedItemsViewStore}
                        item={item}
                        onCellClick={onCellClick}
                    />
                ))}{" "}
            </div>{" "}
        </div>
    );
}

CategoryGroupTemplate.propTypes = {
    onCellClick: PropTypes.func.isRequired,
    premiumSubscriptionStore: PropTypes.object.isRequired,
    goTo: PropTypes.func.isRequired,
    manageSelectedItemsViewStore: PropTypes.object.isRequired,
    item: PropTypes.object.isRequired,
};

export default observer(CategoryGroupTemplate);
